import { capitalize } from '../misc';

export function reportDataCompiler(data) {
  let finalData = [];
  const splitDate = (dateString) =>
    typeof dateString === 'string' ? dateString.split(' ')[0] : 'N/A';
  
  // Helper function to remove SKU code from product names (for Lot/PF products only)
  const removeSkuCode = (productName) => {
    if (!productName || productName === 'N/A') return productName;
    // Remove [SKU_CODE] pattern from the beginning of the string
    return productName.replace(/^\[[^\]]+\]\s*/, '');
  };
  
  data.map((report) => {
    let reportData = {
      po: capitalize(report?.po_name) || 'N/A',
      lot: report?.future_lot || 'N/A',
      pf_name: removeSkuCode(report?.pfd_name) || 'N/A',
      pf_ordered_qty: report?.pfd_ordered_qty || 'N/A',
      pf_produced_qty: report?.pfd_produced_qty || 'N/A',
      pf_produced_date: splitDate(report?.pfd_produced_date),
      rib_name: report?.rib_name || 'N/A',
      rib_ordered_qty: report?.rib_ordered_qty || 'N/A',
      rib_produced_qty: report?.rib_produced_qty || 'N/A',
      rib_produced_date: splitDate(report?.rib_produced_date),
      ip_name: report?.ip_name || 'N/A',
      ip_ordered_qty: report?.ip_ordered_qty || 'N/A',
      ip_cut_qty: report?.ip_cut_qty || 'N/A',
      ip_cut_date: splitDate(report?.ip_cut_date),
      ip_sew_qty: report?.ip_sew_qty || 'N/A',
      ip_sew_date: splitDate(report?.ip_sew_date),
      ip_packed_qty: report?.ip_packed_qty || 'N/A',
      ip_packed_date: splitDate(report?.ip_packed_date),
      fp_name: report?.fp_name || 'N/A',
      fp_ordered_qty: report?.fp_ordered_qty || 'N/A',
      fp_packed_qty: report?.fp_packed_qty || 'N/A',
      fp_packed_date: splitDate(report?.fp_packed_date),
      fp_cut_qty: report?.fp_cut_qty || 'N/A',
      fp_cut_date: splitDate(report?.fp_cut_date),
      fp_sew_qty: report?.fp_sew_qty || 'N/A',
      fp_sew_date: splitDate(report?.fp_sew_date),
    };
    finalData.push(reportData);
  });
  return finalData;
}
